<template>
  <div
    ref="modalContainer"
    class="_modal-container"
  >
    <div
      :class="['modal', className, modalType]"
      data-reveal
    >
      <span
        @click="close"
        v-if="showCloseBtn"
        class="close-btn"
      >&times;</span>
      <slot />
      <slot name="modal-header" />
      <slot name="content" />
      <div
        class="modal-btns"
        v-if="showBtns"
      >
        <slot name="btns" />
      </div>
      <slot name="bottom-content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    className: {
      type: String,
      default: '',
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
    modalType: {
      type: String,
      default: 'small-modal', // medium-modal large-modal
    },
    showBtns: {
      type: Boolean,
      default: true,
    },
    beforeOpenModal: {
      type: Function,
      default: () => { return true },
    },
    afterOpenModal: {
      type: Function,
      default: () => {},
    },
    beforeCloseModal: {
      type: Function,
      default: () => {},
    },
    afterCloseModal: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      modal: null,
    }
  },
  mounted () {
    if (!this.modal) {
      this.modal = new Foundation.Reveal($(this.$refs.modalContainer), {
        closeOnEsc: false,
        closeOnClick: false,
      })
    }
  },
  methods: {
    async open () {
      const open = await this.beforeOpenModal()
      if (open) {
        this.modal.open()
        await this.afterOpenModal()
      }
    },
    async close () {
      await this.beforeCloseModal()
      this.modal.close()
      await this.afterCloseModal()
    },
    destroyFoundationRevealInstance () {
      if (this.modal) {
        try {
          this.modal.close()
          this.modal.destroy()
        } catch (err) {
          // do nothing
        } finally {
          delete this.modal
        }
      }
      $(this.$refs.modalContainer).remove()
    },
  },
  beforeDestroy () {
    this.destroyFoundationRevealInstance()
  },
}
</script>

<style lang="scss" scoped>
._modal-container {
  $padding-top-bottom: 50px;

  min-height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: Verdana;
  align-items: center;
  padding: $padding-top-bottom 0;

  .font-bold {
    font-weight: bold;
  }
  .base-modal {
    margin-top: 8%;
    align-self: baseline;
  }
  .small-modal {
    @extend .base-modal;
    width: 500px;
  }
  .medium-modal {
    @extend .base-modal;
    width: 700px;
  }
  .large-modal {
    width: 75vw;
    max-height: calc(100vh - #{$padding-top-bottom * 2});
    overflow-y: auto;
  }
  .modal {
    background: #ffffff;
    padding: 30px;
    padding-bottom: 0px;
    &::after {
      content: "";
      display: block;
      height: 30px;
    }
    position: relative;
    .modal-header {
      font-size: 18px;
      color: #0c3a58;
    }
    div.modal-btns {
      padding-top: 20px;
      font-size: 0;
      text-align: right;
      button {
        display: inline;
        margin-right: 15px;
        font-size: 14px;
      }
      button:last-of-type {
        margin-right: 0;
      }
    }
    .close-btn {
      font-weight: normal !important;
      text-align: right;
      color: #0C3A58;
      cursor: pointer;
      font-size: 30px;
      height: 30px;
      line-height: 30px;
      font-family: sans-serif;
      position: absolute;
      right: 10px;
      top: 5px;
    }
  }
}
._modal-container:focus, .modal:focus {
    outline: none;
}
</style>
